import React, { ReactNode } from 'react';
import Sidebar from '../Sidebar';
import ProtectedRoute from '../auth/ProtectedRoute';
import { SidebarStateProps } from '../../hooks/useSidebarState';

interface ProtectedLayoutProps {
  children: ReactNode;
  currentPath: string;
  fullscreenClass?: string;
  showSidebar?: boolean;
  sidebarProps: SidebarStateProps;
}

/**
 * Layout component for protected routes with sidebar.
 * Receives sidebar props from parent to maintain single state instance.
 */
const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ 
  children, 
  currentPath, 
  fullscreenClass = '',
  showSidebar = true,
  sidebarProps,
}) => {
  return (
    <ProtectedRoute>
      <div className={`App ${fullscreenClass}`}>
        {showSidebar && (
          <Sidebar
            {...sidebarProps}
            currentPath={currentPath}
          />
        )}
        {children}
      </div>
    </ProtectedRoute>
  );
};

export default ProtectedLayout;

